module.exports = __webpack_public_path__ + "entry-150bfe9b/holmes-photo-2300e67af7821289c1cba285f993a53f.webp";